import { Injectable } from "@angular/core";
import { WizardAbstractService } from "./wizard-abstract.service";
import { WizardStep } from "@app/core/model/wizard-step";
import { WizardIdEnum } from "@app/core/model/enum/wizard-id.enum";

@Injectable({
    providedIn: 'root'
})
export class NavigationBlockWizardMobileService extends WizardAbstractService {
    constructor() {
        super();
        this.initRoute = '/offers';
        this.idWizard = WizardIdEnum.NAVIGATION_BLOCK;
        this.label = 'VITAFRAIS: Block de navigation dans le catalogue';
        this.description = 'Apprenez à naviguer dans le catalogue, ce guide n\'est disponible que sur vitafrais.';


        const stepDiscoverNavigationBlock = WizardStep.create('discover-navigation-block', this)
            .withTitle('Nouveautés!')
            .withText(`Avez-vous découvert notre tout nouvel espace promotions?`)
            .attachTo('#filters-block', 'bottom')
            .waitForElement(2000)
            .disableTargetInteraction()
            .addNextButton()
            .build();

        const stepDiscoverLesBonnesAffaires = WizardStep.create('discover-les-bonnes-affaires', this)
            .withTitle('Les bonnes affaires')
            .withText(`Profitez de nombreuses références à <strong>-30 %</strong>, cumulables avec vos conditions commerciales.`)
            .attachTo('#les-bonnes-affaires-btn', 'bottom')
            .waitForElement(2000)
            .addNextButton()
            .build();

        const stepDiscoverAntiGaspi = WizardStep.create('discover-anti-gaspi', this)
            .withTitle('Anti-Gaspi')
            .withText(`Bénéficiez de <strong>-50%</strong> sur une sélection de produits à dates courtes, non cumulables avec vos conditions commerciales.`)
            .attachTo('#anti-gaspi-btn', 'bottom')
            .waitForElement(2000)
            .addCompleteButton()
            .build();





        this.addStep(stepDiscoverNavigationBlock);
        this.addStep(stepDiscoverLesBonnesAffaires);
        this.addStep(stepDiscoverAntiGaspi);
    }

}